import { render, staticRenderFns } from "./running.vue?vue&type=template&id=360dfb72&scoped=true&"
import script from "./running.vue?vue&type=script&lang=js&"
export * from "./running.vue?vue&type=script&lang=js&"
import style0 from "./running.vue?vue&type=style&index=0&id=360dfb72&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "360dfb72",
  null
  
)

export default component.exports